import React, { useEffect, useState } from "react";
import { useScroll, useSpring } from "framer-motion";
import { Nav, NavBar, NavLink, Progress } from "./NavbarStyledComponent";
import { SNAP } from "../../utils/motion";

// Four links, matching the objective. The logo, search trigger, GitHub link and
// résumé button that lived here before now live inside the About character
// sheet, so the bar stays as small as the objective's.
const links = [
  { id: "about", label: "About" },
  { id: "experience", label: "Experience" },
  { id: "projects", label: "Projects" },
  { id: "connect", label: "Connect" },
];

const Navbar = () => {
  const [active, setActive] = useState("about");

  // Reading progress, smoothed so it glides instead of tracking scroll 1:1.
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 28,
    restDelta: 0.001,
  });

  // Scroll-spy: highlight the link for the section in view.
  useEffect(() => {
    const sections = links
      .map((l) => document.getElementById(l.id))
      .filter(Boolean);
    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: "-45% 0px -50% 0px", threshold: 0 }
    );
    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  return (
    <Nav>
      <NavBar
        initial={{ opacity: 0, y: -14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: SNAP, delay: 0.15 }}
      >
        {links.map((l) => (
          <NavLink key={l.id} href={`#${l.id}`} $active={active === l.id}>
            {l.label}
          </NavLink>
        ))}
        <Progress style={{ scaleX }} aria-hidden="true" />
      </NavBar>
    </Nav>
  );
};

export default Navbar;
